export enum TrendingTopicsTableRowEnum {
 NAME = 'Topic_filter',
 CURRENT_WEEK = 'Current_week',
 CHANGE = 'change',
 PREVIOUS_WEEK = 'Previous_week'
}
